interface ToolLinkCardProps {
  /** Tool title */
  title: string
  /** Short description (1 line) */
  description: string
  /** Link destination */
  href?: string
  /** Additional classes on the wrapper */
  className?: string
}

export function ToolLinkCard({
  title,
  description,
  href,
  className = "",
}: ToolLinkCardProps) {
  const Wrapper = href ? "a" : "div"
  const wrapperProps = href ? { href } : {}

  return (
    <Wrapper
      {...wrapperProps}
      className={`group flex items-center gap-4 bg-gray-50 hover:bg-gray-100 rounded-lg px-5 py-4 transition-colors ${className}`}
    >
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-gray-900 group-hover:text-[#0469f0] transition-colors">
          {title}
        </h3>
        <p className="text-xs text-gray-500 truncate mt-0.5">{description}</p>
      </div>
      <div className="w-9 h-9 rounded-lg bg-[#0469f0]/10 group-hover:bg-[#0469f0]/20 flex items-center justify-center flex-shrink-0 transition-colors">
        <svg className="w-4 h-4 text-[#0469f0]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </Wrapper>
  )
}
